angular.module('picmonic-common')
    .factory("UserService", ["$cookies", "$q", '$filter', '$state', '$location', "User", "MarketOptionsConfig", "deviceDetector", "UserAgentMatch", "FacebookService", "RaygunService", "IntercomService", function($cookies, $q, $filter, $state, $location, User, MarketOptionsConfig, deviceDetector, UserAgentMatch, FacebookService, RaygunService, IntercomService){
        return {
            user: new User(window.pls_config.user),
            user_badges: false,
            cancelRecommended: $q.defer(),
            recommendationPromise: false,

            getBadges: function(force) {
                if(force || !this.user_badges) {
                    this.user_badges = User.get({ resource: 'badges' });
                }

                return this.user_badges;
            },

            getRecommendations: function() {
                var self = this;
                if(self.recommendationPromise) {
                    self.cancelRecommended.resolve();
                }

                self.recommendationPromise = User.recommended({type:'browse'}, {timeout: self.cancelRecommended}, function(data) {
                    self.recommended = data;
                });

                return this.recommendationPromise;
            },

            recommended: false,

            awardBadge: function(badge) {
                var self = this;
                var promise = User.post({resource:'badges'}, {badge:badge});

                promise.$promise.then(function(result){
                    if(result){
                        self.user_badges.badges.push(result);
                    }
                });
                return promise;
            },

            /**
             * Get a specific badge (or false)
             * @param badge - The name of the badge you're looking for
             * @param callback - The callback that will receive the result
             */
            getBadge: function(badge, callback) {
                // When we get the badges, find the badge we're looking for and pass the result to the callback
                var withBadges = function(result) {
                    var matching = $filter('filter')(result.badges, {badge: badge});
                    callback(!!(matching && matching.length));
                };

               return this.getBadges().$promise.then(withBadges);
            },

            setCookieIfNotLoggedIn: function(name, value) {
                var self = this;
                if(!self.user.user_id) {
                    $cookies.put('pls_user_'+name, value);
                }
            },
            
            quizSplitText: function() {
                var self = this;
                if (self.user.beta_user_flag) {
                    return true;
                } else {
                    var show_quiz_cookie = $cookies.get('pls_user_show_quiz');
                    if (!show_quiz_cookie) {
                        return false;
                    } else {
                        if (show_quiz_cookie == 'true') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            },
            
            generateTypeFormURL: function(typeFormId, extraParams) {
                var self = this;
                var url = "https://picmonic.typeform.com/to/"+typeFormId;
                var params = [
                    'user_id='+self.user.user_id,
                    'email='+encodeURIComponent(self.user.email),
                    'vertical='+self.user.lead,
                    'subscription_type='+(self.user.is_trial?'Free':'Paid'),
                    'subscription_exp='+encodeURIComponent($filter('date')(new Date(self.user.expiration * 1000), "MM-dd-yyyy hh:mm a")),
                    'school_name='+encodeURIComponent(self.user.school?self.user.school.name:''),
                    'cards_mastered='+self.user.cards_mastered,
                    'os='+encodeURIComponent(deviceDetector.os),
                    'browser='+encodeURIComponent(deviceDetector.browser),
                    'advocate='+(self.user.is_advocate?'yes':'no'),
                    'grad_year='+(self.user.graduation_year?self.user.graduation_year:'')
                ];

                if (extraParams) {
                    params = params.concat(extraParams);
                }

                url += '?'+params.join("&");

                return url;
            },
            getReferralCodeAndSuffix: function(type) {
                var self = this;

                return self.user.referrer_code + self.getReferralSuffix(type);
            },
            getFullReferralUrl: function(type){
                var self = this;

                var pathArray = location.href.split( '/' );
                var protocol = pathArray[0];
                var host = pathArray[2];
                var url = protocol + '//' + host;

                return url + '/referrals/' + self.user.referrer_code + self.getReferralSuffix(type);
            },
            getReferralSuffix: function(type) {
                var date = new Date();
                var month = $filter('date')(date, 'M');
                var month_char = String.fromCharCode(parseInt(month, 10)+96).toUpperCase();
                var day = $filter('date')(date, 'd');
                var day_char;
                if (day > 26) {
                    day_char = parseInt(day, 10) - 26;
                } else {
                    day_char = String.fromCharCode(parseInt(day, 10)+96).toUpperCase();
                }

                var type_code = 'L';
                switch(type) {
                    case "facebook":
                        type_code = 'F';
                        break;
                    case "twitter":
                        type_code = 'T';
                        break;
                    case "email":
                        type_code = 'E';
                        break;
                    default:
                    case "link":
                        type_code = 'L';
                        break;
                }

                return type_code + month_char + day_char + $filter('date')(date, 'yy');
            },
            socialRegister: function(redirect, redirectUrl){
                return this.socialLogin(redirect, true, redirectUrl);
            },
            socialLogin: function(redirect, register, redirectUrl){
                var self = this;

                self.user.accessToken = null;

                if ((navigator.userAgent.indexOf('Crosswalk') > -1) || (navigator.userAgent.indexOf('CriOS') > -1)) {
                    document.location.href="https://www.facebook.com/dialog/oauth?client_id=491312997564602&redirect_uri=https://"+window.location.host+"/register/social";
                } else {
                    return FacebookService.login().then(function(data){
                        self.user.accessToken = data.authResponse.accessToken;
                        if (register) {
                            return self.register(redirect, redirectUrl);
                        } else {
                            return self.login(redirect, redirectUrl);
                        }
                    });
                }
            },
            register: function(redirect, redirectUrl) {
                redirect = (typeof redirect != 'undefined' ? redirect : true);
                redirectUrl = (typeof redirectUrl != 'undefined' ? redirectUrl : null);
                var self = this;

                self.user.registerSource = (UserAgentMatch.onMobileDevice() ? 'mobile-web' : 'desktop');
                self.user.registration_source_device = deviceDetector.device;
                self.user.registration_source_browser = deviceDetector.browser;
                self.user.resource = '';

                return self.user.$save(function(data){
                    var urlparams = $location.search();
                    RaygunService.setRayGunUserInfo(self.user);
                    IntercomService.setUserInfo(self.user, true);

                    if ((typeof atlasEvent !== 'undefined') && (!data.alreadyExists)) {
                        send_ga('event', 'Register', 'Web-App Registration', data.lead);
                        atlasEvent('register', data.lead, 'new_user');
                        atlasEvent('register', data.lead, 'new_public_onboarding');
                        atlasEvent('register', data.lead, 'user_flow_7_2017', 'required');
                        IntercomService.trackEvent('signup');
                        var tracking = new Image();
                        tracking.src = "//www.googleadservices.com/pagead/conversion/941316450/?label=0ctSCPS2k2QQ4rLtwAM&amp;guid=ON&amp;script=0";
                        var fbtracking = new Image();
                        fbtracking.src = "https://www.facebook.com/tr?id=759705864106825&ev=CompleteRegistration&noscript=1";

                        // Bing Conversion Event
                        window.uetq = window.uetq || [];
                        window.uetq.push({'ec':'Register', 'ea':'Web-App Registration', 'el':data.lead, 'ev':0 });
                    }

                    if (redirect) {
                        if (data.alreadyExists) {
                            if (urlparams.redirect) {
                                if (urlparams.redirect.indexOf('/') === 0) {
                                    urlparams.redirect = urlparams.redirect.substring(1);
                                }
                                if (urlparams.redirect.indexOf('%2F') === 0) {
                                    urlparams.redirect = urlparams.redirect.substring(3);
                                }
                                top.location = '/' + urlparams.redirect;
                            } else {
                                urlparams.browseOpen = 1;
                                top.location = '/home?' + $.param(urlparams);
                            }
                        } else if ((urlparams.skip_school) && (urlparams.redirect) && data.role && data.lead) {
                            if (urlparams.redirect.indexOf('/') === 0) {
                                urlparams.redirect = urlparams.redirect.substring(1);
                            }
                            if (urlparams.redirect.indexOf('%2F') === 0) {
                                urlparams.redirect = urlparams.redirect.substring(3);
                            }
                            top.location = '/' + urlparams.redirect;
                        } else if (redirectUrl) {
                            if (redirectUrl.indexOf('/') === 0) {
                                redirectUrl = redirectUrl.substring(1);
                            }
                            if (redirectUrl.indexOf('%2F') === 0) {
                                redirectUrl = redirectUrl.substring(3);
                            }
                            top.location = '/' + redirectUrl;
                        } else if(data.role && data.lead && (data.program || !MarketOptionsConfig.getProgramsByMarketId(data.lead))){
                            $location.url('/register/step3?' + $.param(urlparams));
                        }else{
                            $location.url('/register/step2?' + $.param(urlparams));
                        }
                    }
                });
            },
            login: function(redirect, redirectUrl) {
                redirect = (typeof redirect != 'undefined' ? redirect : true);
                redirectUrl = (typeof redirectUrl != 'undefined' ? redirectUrl : null);
                var self = this;

                self.user.resource = 'authenticate';

                return self.user.$save(function(data){
                    var urlparams = $location.search();

                    RaygunService.setRayGunUserInfo(self.user);
                    IntercomService.setUserInfo(self.user, true);
                    IntercomService.trackEvent('login');

                    if (redirect) {
                        if (!data.lead || !data.role) {
                            $location.url('/login/step2?' + $.param(urlparams));
                        } else if (!data.school) {
                            $location.url('/login/step3?' + $.param(urlparams));
                        } else {
                            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                            var isMobileAndroidApp = ((userAgent.indexOf('Crosswalk') > -1) || (userAgent.indexOf('CriOS') > -1));

                            if (navigator.userAgent.indexOf('Crosswalk') > -1) {
                                top.location = $location.protocol() + '://' + $location.host() + (urlparams.redirect ? urlparams.redirect : '/home');
                            } else if (!isMobileAndroidApp && (!urlparams.redirect || urlparams.redirect && urlparams.redirect.indexOf('typeform') !== 0) && /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
                                top.location = $location.protocol() + '://' + $location.host() + '/login/mobile-app?redirect=' + (urlparams.redirect ? urlparams.redirect : '/home');
                            } else if ((data.role == 'Professor') || (data.role == 'Administrator')) {
                                top.location = (urlparams.redirect ? urlparams.redirect : '/educator');
                            } else if (urlparams.redirect) {
                                if (urlparams.redirect.indexOf('/') === 0) {
                                    urlparams.redirect = urlparams.redirect.substring(1);
                                }
                                if (urlparams.redirect.indexOf('%2F') === 0) {
                                    urlparams.redirect = urlparams.redirect.substring(3);
                                }
                                top.location = '/' + urlparams.redirect;
                            } else if (redirectUrl) {
                                if (redirectUrl.indexOf('/') === 0) {
                                    redirectUrl = redirectUrl.substring(1);
                                }
                                if (redirectUrl.indexOf('%2F') === 0) {
                                    redirectUrl = redirectUrl.substring(3);
                                }
                                top.location = '/' + redirectUrl;
                            } else {
                                urlparams.browseOpen = 1;
                                top.location = '/home?' + $.param(urlparams);
                            }
                        }
                    }
                });
            },
            setMarketCookies: function(marketId) {
                var self = this,
                    market = MarketOptionsConfig.getMarketById(marketId);

                if (market.is_pseudo) {
                    self.setCookieIfNotLoggedIn('lead_secondary', marketId);
                } else {
                    self.setCookieIfNotLoggedIn('lead', marketId);
                }

                self.setCookieIfNotLoggedIn('role', 'Student');
            }
        };
    }]);
